const Chat = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.25 5.375H8M4.25 8H10.25M6.26281 12.5H11.15C12.4101 12.5 13.0402 12.5 13.5215 12.2548C13.9448 12.039 14.289 11.6948 14.5048 11.2715C14.75 10.7902 14.75 10.1601 14.75 8.9V4.85C14.75 3.58988 14.75 2.95982 14.5048 2.47852C14.289 2.05516 13.9448 1.71095 13.5215 1.49524C13.0402 1.25 12.4101 1.25 11.15 1.25H4.85C3.58988 1.25 2.95982 1.25 2.47852 1.49524C2.05516 1.71095 1.71095 2.05516 1.49524 2.47852C1.25 2.95982 1.25 3.58988 1.25 4.85V14.2516C1.25 14.6513 1.25 14.8511 1.33192 14.9537C1.40317 15.043 1.5112 15.0949 1.6254 15.0948C1.75672 15.0946 1.91275 14.9698 2.22482 14.7201L4.01391 13.2889C4.37939 12.9965 4.56213 12.8503 4.76561 12.7463C4.94615 12.6541 5.13832 12.5867 5.33691 12.5459C5.56075 12.5 5.79477 12.5 6.26281 12.5Z"
      stroke="#535862"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Chat;
